import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${colors.almostBlack};
    margin-right: 1rem;
    margin-left: 1rem;
  }

  .container :global(.text-show-more-container .text, .text-show-more-container span, .text-show-more-container div, .text-show-more-container .button) {
    ${common.text};
    color: ${colors.pureWhite};
    text-align: left;
    font-family: 'Nexa Regular', sans-serif;
    font-size: 1.6rem;
  }
/* 
  .container :global(.show-more-less-clickable) {
    display: none;
  } */

  p.title {
    ${common.sub};
    color: ${colors.yellow};
    margin-top: 4rem;
    margin-bottom: 3rem;
    font-family: 'Taviraj-Light', serif;
    text-align: left;
    width: 100%;
  }

  p.text {
    ${common.text};
    font-family: 'Nexa Regular', sans-serif;
    font-size: 1.6rem;
    color: ${colors.pureWhite};
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      margin-bottom: 4rem;
    }
  }
`
